import React, { useState, useEffect } from 'react';
import './Carousel.css';
import Al from '../../../assets/CarouselLeftArrow.png'

const Carou = ({ 
  itemWidth, 
  itemHeight, 
  items = [], 
  margin = 50
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalItems = items.length;

  // Don't render if no items
  if (!items || items.length === 0) {
    return null;
  }

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalItems);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalItems) % totalItems);
  };

  const getVisibleItems = () => {
    // Ensure we have at least 3 items
    if (items.length < 3) {
      return items;
    }

    const prevIndex = (currentIndex - 1 + totalItems) % totalItems;
    const nextIndex = (currentIndex + 1) % totalItems;
    return [
      items[prevIndex],
      items[currentIndex],
      items[nextIndex]
    ];
  };

  return (
    <div style={{position:'relative'}} className="carousel">
      <button className="carousel-btn left" onClick={prevSlide}>
        <img src={Al} alt="" />
      </button>
      <div className="carousel-items-container">
        {getVisibleItems().map((item, index) => (
          <div
            key={`${currentIndex}-${index}`}
            className={`carousel-item ${index === 1 ? 'carousel-center' : ''}`}
            style={{
              width: `${itemWidth}px`,
              height: `${itemHeight}px`,
              transform: index === 1 ? 'scale(1.1)' : 'scale(1)'
            }}
          >
            {item?.content}
          </div>
        ))}
      </div>
      <button className="carousel-btn right" onClick={nextSlide}>
        <img src={Al} alt="" style={{ transform: 'scaleX(-1)' }} />
      </button>
    </div>
  );
};

export default Carou;